import {createTheme} from '@mui/material/styles';
import {typography} from '../tokens/typography';

/**
 * Figtree is the intentional brand font for all MUI consumers.
 * Palette and component defaults remain MUI v5 until broader visual
 * standardization; only typography.fontFamily is wired from tokens.
 */
export const designSystemTheme = createTheme({
  typography: {
    fontFamily: typography.fontFamily,
  },
});
